class PedagogicalApproachAreaController {
    /**
     * @param {Object} evaluationService
     * @param {Object} pedagogicalService
     * @param {Object} $stateParams
     * @param {Object} $state
     * @param {Object} $scope
     */
    constructor(evaluationService, pedagogicalService, $stateParams, $state, $scope) {
        this.evaluationService = evaluationService;
        this.pedagogicalService = pedagogicalService;
        this.$state = $state;
        this.$scope = $scope;
        this.evaluationId = $stateParams.id;
        this.areaId = parseInt($stateParams.subjectAreaId, 10);
        this.isSubjectArea = !this.areaId;
        this.skillsGroup = {};
        this.stepName = 'Pedagogical Approach';
    }

    $onInit() {
        this.init();
    }

    init() {
        this.pedagogicalService.getAllSkills().then((res) => {
            if (this.areaId) {
                const currArea = res.find(e => e.id === this.areaId);
                this.areaName = currArea.name;
                this.currSubcategories = currArea.subcategories;
            } else {
                this.areaName = 'Subject Area';
            }
        }).then(() => {
            this.evaluationService.getEvaluationData(this.evaluationId, this.$state.includes('mini')).then((data) => {
                if (this.areaId) {
                    this.areaSkills = data.learningGoals
                        .filter(skill => ((skill.subjectAreaId === this.areaId) && (['A', 'B', 'C'].indexOf(skill.importance) > -1)));
                    Object.keys(this.areaSkills).forEach((key) => {
                        const newCat = this.currSubcategories
                            .find(cat => cat.id === this.areaSkills[key].subcategoryId).name;
                        if (!this.skillsGroup[newCat]) {
                            this.skillsGroup[newCat] = [newCat];
                        }
                        this.skillsGroup[newCat].push(this.areaSkills[key]);
                    });
                } else {
                    this.areaSkills = data.learningGoals
                        .filter(skill => (skill.isSubjectAreaDefault === false && (['A', 'B', 'C'].indexOf(skill.importance) > -1)));
                }
            });
        }).catch((err) => {
            console.error('ERROR', err);
        });
    }

    selectSkill(skill) {
        this.$scope.$broadcast('CHANGE_SKILL', { id: this.currentSkillId, name: this.currentSkillName });
        this.currentSkillId = skill.skillId;
        this.currentSkillName = skill.name;
    }
}

PedagogicalApproachAreaController.$inject = [
    'EvaluationService',
    'PedagogicalService',
    '$stateParams',
    '$state',
    '$scope',
];

export default PedagogicalApproachAreaController;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepPedagogicalApproach/pages/pedagogicalApproachAreaController.js